import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import MyPerformance from '../../my-performance'
import dataLoad from '../../../actions/data-load';

function mapStateToProps(state) {
    // console.log('state ====>', state);
    return {
        myPerformance: state.myPerformance,
        performanceYears: state.performanceYears,
        ajaxStatuses: state.ajaxStatuses.dataLoad,
        user: state.user,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        dataLoad,
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(MyPerformance);